import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ProductsConfigService, StrategiesService } from '@approot/services';
import { LegComponent } from '@approot/widgets';

@Component({
  selector: 'app-save-strategy',
  templateUrl: './save-strategy.component.html',
  styleUrls: ['./save-strategy.component.scss']
})
export class SaveStrategyComponent {
  @Input() isModalOpened = false;
  @Input() legs: LegComponent[];
  @Output() saveStrategyOpenChanged = new EventEmitter<boolean>();
  @Output() strategySaved = new EventEmitter<boolean>();
  form: FormGroup;

  constructor(
    private fb: FormBuilder,
    private strategiesService: StrategiesService,
    private productsConfigService: ProductsConfigService
  ) {
    this.form = this.fb.group({
      name: this.fb.control('', [Validators.required])
    });
  }

  onSubmit() {
    this.onStrategySaved();
  }

  get savingInfo(): string {
    return this.strategiesService.savingInfo;
  }

  onStrategySaved() {
    this.strategiesService.saveStrategy({
      name: this.form.get('name').value,
      timestamp: new Date().getTime(),
      products: this.legs.map((l: LegComponent) => {
        let product = this.productsConfigService.productFormatter(
          l.form.value,
          l.leg.attributes
        );

        if (l.leg.productType === 'newdcd' && product['margin'] !== undefined) {
          // if the product is newdcd remove margin value
          product['margin'] = '';
        }
        return product;
      })
    });
  }

  close() {
    this.modalChanged(false);
  }

  modalChanged(event) {
    this.saveStrategyOpenChanged.emit(event);
  }
}
